import "../css/eventsList.css";
import {useState, useEffect} from "react";
import {BASE_URL} from "../constants";
import { useLanguage } from "../components/Language.js";

function EditEvent({onclose, event_id, title, description, start_time, end_time, start_date, end_date, postcode, latitude, longitude, event_picture, 
    event_proficiency, type, age_bracket, language, performCheckinUpdate, performLikeUpdate, performEventDetailUpdate, fetchEvents}) {

    console.log({title});
    let username = JSON.parse(sessionStorage.getItem("USER"))['username']


    const [isEditingTitle, setIsEditingTitle] = useState(false);
    const [isEditingPicture, setIsEditingPicture] = useState(false);
    const [isEditingDescription, setIsEditingDescription] = useState(false);
    const [isEditingStartTime, setIsEditingStartTime] = useState(false);
    const [isEditingEndTime, setIsEditingEndTime] = useState(false);
    const [isEditingStartDate, setIsEditingStartDate] = useState(false);
    const [isEditingEndDate, setIsEditingEndDate] = useState(false);
    const [isEditingPostcode, setIsEditingPostcode] = useState(false);
    const [isEditingLatitude, setIsEditingLatitude] = useState(false);
    const [isEditingLongitude, setIsEditingLongitude] = useState(false);
    const [isEditingProficiency, setIsEditingProficiency] = useState(false);
    const [isEditingType, setIsEditingType] = useState(false);
    const [isEditingAgeBracket, setIsEditingAgeBracket] = useState(false);
    const [isEditingLanguage, setIsEditingLanguage] = useState(false);

    const [newTitle, setNewTitle] = useState(title);
    const [newImageFile, setNewImageFile] = useState(event_picture);
    const [newImageUrl, setNewImageUrl] = useState(event_picture);
    const [newDescription, setNewDescription] = useState(description);
    const [newStartTime, setNewStartTime] = useState(start_time);
    const [newEndTime, setNewEndTime] = useState(end_time);
    const [newStartDate, setNewStartDate] = useState(start_date);
    const [newEndDate, setNewEndDate] = useState(end_date);
    const [newPostcode, setNewPostcode] = useState(postcode);
    const [newLatitude, setNewLatitude] = useState(latitude);
    const [newLongitude, setNewLongitude] = useState(longitude);
    const [newProficiency, setNewProficiency] = useState(event_proficiency);
    const [newType, setNewType] = useState([]);
    const [newAge, setNewAge] = useState(age_bracket);
    const [newLanguage, setNewLanguage] = useState(language);

    const {language: siteLanguage} = useLanguage();

    const translations = {
        en: {
            editEvent: `Hi ${username} you are editing the following event: ${title}`,
            title: "Title: ",
            update: "Update",
            edit: "Edit",
            picture: "Picture: ",
            Description: "Description: ",
            startTime: "Start Time: ",
            endTime: "End Time: ", 
            startDate: "Start Date: ",
            endDate: "End Date: ",
            postcode: "Postcode: ",
            Latitude: "Laitude: ",
            longitude: "Longitude: ",
            proficencyLevel: "Proficency Level: ",
            allLevelsWelcome: "All Levels Welcome",
            beginner: "Beginner",
            intermediate: "Intermediate",
            advanced: "Advanced",
            eventType: "Event Type: ",
            family: "Family",
            babyAndToddlers: "Baby and Toddlers",
            musicAndDance: "Music and Dance",
            conversationGroup: "Conversation Group",
            artsAndCrafts: "Arts and Crafts",
            talkLecture: "Talk/Lecture",
            universityEvent: "University Event",
            Session: "Session",
            pubNight: "Pub Night",
            religious: "Religious",
            meeting: "Meeting",
            CoffeeMorning: "Coffee Morning",
            ageBracket: "Age Bracket: ",
            preSchoolChildren: "Pre-School Children",
            schoolAgedChildren: "School Aged Child",
            teenagers: "Teenagers",
            adults: "Adults",
            allAgesWelcome: "All Ages Welcome",
            language: "Language: ",
            gaelicOnly: "Gaelic Only",
            gaelicAndEnglish: "Gaelic and English",
            
               
        },

        gd: {
            edit: `Haidh ${username}, tha thu a' deasachadh an tachartais a leanas: ${title}`,
            title: "Tiotal: ",
            update: "Ùraich",
            edit: "Deasaich",
            picture: "Dealbh: ",
            Description: "Tuairisgeul: ",
            startTime: "Àm tòiseachaidh: ",
            endTime: "Àm crìochnachaidh",
            startDate: "Ceann-latha tòiseachaidh: ",
            endDate: "Ceann-latha crìochnachaidh",
            postcode: "Còd-puist",
            Latitude: "Domhan-leud: ",
            longitude: "Domhan-fhad: ",
            proficencyLevel: "Ìre Comais: ",
            allLevelsWelcome: "Gach Ìre Di-beathte",
            beginner: "Neach-tòiseachaidh",
            intermediate: "Eadar-mheadhanach",
            advanced: "Adhartach",
            eventType: "Seòrsa Tachartais: ",
            family: "Teaghlach",
            babyAndToddlers: "Leanabh is Pàistean",
            musicAndDance: "Ceòl is Dannsa",
            conversationGroup: "Buidheann Còmhraidh",
            artsAndCrafts: "Ealain is Ciùird",
            talkLecture: "Còmhradh / Òraid",
            universityEvent: "Tachartas Oilthighe",
            Session: "Seisean",
            pubNight: "Oidhche Taigh-seinnse",
            religious: "Cràbhach",
            meeting: "Coinneamh",
            CoffeeMorning: "Madainn Cofaidh",
            ageBracket: "Raon aoise: ",
            preSchoolChildren: "Clànn Fo-sgoile",
            choolAgedChildren: "Clann Aois-sgoile ",
            teenagers: "Deugairean",
            adults: "Inbhich",
            allAgesWelcome: "Gach Aois Di-beathte",
            language: "Cànan: ",
            gaelicOnly: "Gàidhlig a-mhàin",
            gaelicAndEnglish: "Gàidhlig agus Beurla",
            
            
        },
    };

    //for retrieving event object after title is updated 
    const [previousTitle, setPreviousTitle] = useState(title);
    const [typeString, setTypeString] = useState(type.replace(/['"]+/g, '').replace('[', '').replace(']', '').split(","));

    const handlePictureEdit = async(e) => {
        const file = e.target.files[0];
        if (file) {
            setNewImageFile(file);
            // console.log(newImageFile);
            setNewImageUrl(URL.createObjectURL(file));
        }
    }

    const handlePictureEditSave = async(e) => {
        
        const imageData = new FormData();

        imageData.append('picture', newImageFile);
        imageData.append('event_id', event_id);

        try {
            await fetch(`${BASE_URL}/api/save_event_picture/`, {
                method: "POST",
                body: imageData,
            });

            setIsEditingPicture(false);

        }catch (error) {
            console.error("Unable to save new event picture");
        }
    }


    const handleEventTypeChange = (e) => {
        const {name, value} = e.target;
        console.log(name);
        console.log(value);
        let currentEventType = newType;
        (currentEventType.includes(value) ? currentEventType.splice(currentEventType.indexOf(value), 1) : currentEventType.push(value) );
        setNewType(currentEventType);
        setTypeString(currentEventType.toString());
    };


    async function handleEditSave (field, newValue) {

        if (!performEventDetailUpdate) {
            console.error("performEventDetailUpdate is not available!");
            return;
        }

        let res = await performEventDetailUpdate(event_id, field, newValue);

        if (JSON.parse(res)["error"]){
            //title in use, return 
            return;
        }

        switch(field){
            case "title":
                setIsEditingTitle(false);
                setPreviousTitle(newValue);
                console.log("prev now curr ", previousTitle);
                break;

            case "description":
                setIsEditingDescription(false);
                break;

            case "start_time":
                setIsEditingStartTime(false);
                break;

            case "end_time":
                setIsEditingEndTime(false);
                break;

            case "start_date":
                setIsEditingStartDate(false);
                break;

            case "end_date":
                setIsEditingEndDate(false);
                break;

            case "postcode":
                setIsEditingPostcode(false);
                break;

            case "latitude":
                setIsEditingLatitude(false);
                break;

            case "longitude":
                setIsEditingLongitude(false);
                break;

            case "event_proficiency":
                setIsEditingProficiency(false);
                break;

            case "event_type":
                setIsEditingType(false);
                break;
            
            case "age_bracket":
                setIsEditingAgeBracket(false);
                break;

            case "language":
                setIsEditingLanguage(false);
                break;

            default:
                break;
                
        }
    }

    return(
        <>
        <h4> {translations[siteLanguage].editEvent} </h4>
        <div className="event-card">


          <div className="edit-row">
            <h4 className = "event-title">{translations[siteLanguage].title}  
                {isEditingTitle ? ( <input type="text" value={newTitle} onChange = {(e) => setNewTitle(e.target.value)} />) : (newTitle)}  
            </h4>
            {isEditingTitle ? ( <button className="edit-info-button" onClick={() => handleEditSave("title", newTitle)}> {translations[siteLanguage].update} </button>) : (<button className="edit-info-button" onClick={() => setIsEditingTitle(true)}>{translations[siteLanguage].edit}</button>)}
          </div>


          <div className="edit-row">
            <h4 className = "event-picture-label">{translations[siteLanguage].picture}
                {isEditingPicture ? (<input type="file" onChange={(e) => handlePictureEdit(e)} accept="image/*" />): <img className = "event-image" src = {newImageUrl} alt = "event image" />}
            </h4>
            {isEditingPicture ? ( <button className="edit-info-button" onClick={handlePictureEditSave}> {translations[siteLanguage].update} </button>) : (<button className="edit-info-button" onClick={() => setIsEditingPicture(true)}>{translations[siteLanguage].edit}</button>)}
          </div>

          <div className="edit-row">
            <h5 className = "event-description">{translations[siteLanguage].description} 
                {isEditingDescription ? ( <textarea className="event-description"  rows="3" value={newDescription} onChange = {(e) => setNewDescription(e.target.value)} />) : (newDescription)}  
            </h5>
            {isEditingDescription ? ( <button className="edit-info-button" onClick={() => handleEditSave("description", newDescription)}> {translations[siteLanguage].update} </button>) : (<button className="edit-info-button" onClick={() => setIsEditingDescription(true)}>{translations[siteLanguage].edit}</button>)}
          </div>


          <div className="edit-row">
            <p className = "event-start-time">{translations[siteLanguage].startTime} 
                {isEditingStartTime ? ( <input type="time" value={newStartTime} onChange = {(e) => setNewStartTime(e.target.value)} />) : (newStartTime.slice(0, -3))} 
            </p>
            {isEditingStartTime ? ( <button className="edit-info-button" onClick={() => handleEditSave("start_time", newStartTime)}> {translations[siteLanguage].update} </button>) : (<button className="edit-info-button" onClick={() => setIsEditingStartTime(true)}>{translations[siteLanguage].edit}</button>)}

            <p className = "event-end-time">{translations[siteLanguage].endTime}  
                {isEditingEndTime ? ( <input type="time" value={newEndTime} onChange = {(e) => setNewEndTime(e.target.value)} />) : (newEndTime.slice(0, -3))} 
            </p>
            {isEditingEndTime ? ( <button className="edit-info-button" onClick={() => handleEditSave("end_time", newEndTime)}> {translations[siteLanguage].update} </button>) : (<button className="edit-info-button" onClick={() => setIsEditingEndTime(true)}>{translations[siteLanguage].edit}</button>)}
          </div>


          <div className="edit-row">
            <p className = "event-start-date">{translations[siteLanguage].startDate} 
                {isEditingStartDate ? ( <input type="date" value={newStartDate} onChange = {(e) => setNewStartDate(e.target.value)} />) : (new Date(newStartDate).toLocaleDateString("en-UK"))} 
            </p>
            {isEditingStartDate ? ( <button className="edit-info-button" onClick={() => handleEditSave("start_date", newStartDate)}> {translations[siteLanguage].update} </button>) : (<button className="edit-info-button" onClick={() => setIsEditingStartDate(true)}>{translations[siteLanguage].edit}</button>)}

            <p className = "event-end-date">{translations[siteLanguage].endDate} 
                {isEditingEndDate ? ( <input type="date" value={newEndDate} onChange = {(e) => setNewEndDate(e.target.value)} />) : (new Date(newEndDate).toLocaleDateString("en-UK"))}
            </p>
            {isEditingEndDate ? ( <button className="edit-info-button" onClick={() => handleEditSave("end_date", newEndDate)}> {translations[siteLanguage].update} </button>) : (<button className="edit-info-button" onClick={() => setIsEditingEndDate(true)}>{translations[siteLanguage].edit}</button>)}
          </div>


          <div className="edit-row">
            <p className = "event-postcode">{translations[siteLanguage].postcode}
                {isEditingPostcode ? ( <input type="text" value={newPostcode} onChange = {(e) => setNewPostcode(e.target.value)} />) : (newPostcode)} 
            </p>
            {isEditingPostcode ? ( <button className="edit-info-button" onClick={() => handleEditSave("postcode", newPostcode)}> {translations[siteLanguage].update} </button>) : (<button className="edit-info-button" onClick={() => setIsEditingPostcode(true)}>{translations[siteLanguage].edit}</button>)}
          </div>


          <div className="edit-row">
            <p className = "event-location">{translations[siteLanguage].latitude} 
                {isEditingLatitude ? ( <input type="text" value={newLatitude} onChange = {(e) => setNewLatitude(e.target.value)} />) : (newLatitude)}  
            </p>
            {isEditingLatitude ? ( <button className="edit-info-button" onClick={() => handleEditSave("latitude", newLatitude)}> {translations[siteLanguage].update} </button>) : (<button className="edit-info-button" onClick={() => setIsEditingLatitude(true)}>{translations[siteLanguage].edit}</button>)} 
          </div>


          <div className="edit-row">
            <p className = "event-location">{translations[siteLanguage].longitude} 
                {isEditingLongitude ? ( <input type="text" value={newLongitude} onChange = {(e) => setNewLongitude(e.target.value)} />) : (newLongitude)}
            </p>
            {isEditingLongitude ? ( <button className="edit-info-button" onClick={() => handleEditSave("longitude", newLongitude)}> {translations[siteLanguage].update} </button>) : (<button className="edit-info-button" onClick={() => setIsEditingLongitude(true)}>{translations[siteLanguage].edit}</button>)} 
          </div>

        
          <div className="edit-row">
            <p className = "proficiency">{translations[siteLanguage].proficencyLevel} 
                {isEditingProficiency ? ( <select name="event_proficiency" value={newProficiency} onChange = {(e) => setNewProficiency(e.target.value)} >
                                            <option value="all_levels">{translations[siteLanguage].allLevelsWelcome} </option>
                                            <option value="beginner">{translations[siteLanguage].beginner}</option>
                                            <option value="intermediate">{translations[siteLanguage].intermediate}</option>
                                            <option value="advanced">{translations[siteLanguage].advanced}</option>
                                        </select>) : (newProficiency)}
            </p>
            {isEditingProficiency ? ( <button className="edit-info-button" onClick={() => handleEditSave("event_proficiency", newProficiency)}> {translations[siteLanguage].update} </button>) : (<button className="edit-info-button" onClick={() => setIsEditingProficiency(true)}>{translations[siteLanguage].edit}</button>)} 
          </div>


          <div className="edit-row">
            <p className = "event-type">{translations[siteLanguage].eventType} {typeString} <br />
                {isEditingType ? ( <select multiple name="event_type" value={newType} onChange={handleEventTypeChange}>
                                        <option value="family">{translations[siteLanguage].family}</option>
                                        <option value="baby and toddlers">{translations[siteLanguage].babyAndToddlers}</option>
                                        <option value="music and dance">{translations[siteLanguage].musicAndDance}</option>
                                        <option value="conversation group">{translations[siteLanguage].conversationGroup}</option>
                                        <option value="arts and crafts">{translations[siteLanguage].artsAndCrafts}</option>
                                        <option value="talk/lecture">{translations[siteLanguage].talkLecture}</option>
                                        <option value="university event">{translations[siteLanguage].universityEvent}</option>
                                        <option value="session">{translations[siteLanguage].session}</option>
                                        <option value="pub night">{translations[siteLanguage].pubNight}</option>
                                        <option value="religious">{translations[siteLanguage].religious}</option>
                                        <option value="meeting">{translations[siteLanguage].meeting}</option>
                                        <option value="coffee morning">{translations[siteLanguage].CoffeeMorning}</option>
                                    </select>) : <></>}  
            </p>
            {isEditingType ? ( <button className="edit-info-button" onClick={() => handleEditSave("event_type", newType)}> {translations[siteLanguage].update} </button>) : (<button className="edit-info-button" onClick={() => setIsEditingType(true)}>{translations[siteLanguage].edit}</button>)} 
          </div>

          <div className="edit-row">
            <p className = "age-bracket">{translations[siteLanguage].ageBracket} 
                {isEditingAgeBracket ? ( <select name="age_bracket" value={newAge} onChange={(e) => setNewAge(e.target.value)}>
                                        <option value="pre-school children">{translations[siteLanguage].preSchoolChildren}</option>
                                        <option value="school-aged children">{translations[siteLanguage].schoolAgedChildren}</option>
                                        <option value="teenagers">{translations[siteLanguage].teenagers}</option>
                                        <option value="adults">{translations[siteLanguage].adults}</option>
                                        <option value="all ages welcome">{translations[siteLanguage].allAgesWelcome}</option>
                                    </select>) : (newAge)}  
            </p>
            {isEditingAgeBracket ? ( <button className="edit-info-button" onClick={() => handleEditSave("age_bracket", newAge)}> {translations[siteLanguage].update} </button>) : (<button className="edit-info-button" onClick={() => setIsEditingAgeBracket(true)}>{translations[siteLanguage].edit}</button>)} 
          </div>



          <div className="edit-row">
            <p className = "language">{translations[siteLanguage].language} 
                {isEditingLanguage ? ( <select name="language" value={newLanguage} onChange = {(e) => setNewLanguage(e.target.value)} >
                                            <option value="gaelic only">{translations[siteLanguage].gaelicOnly}</option>
                                            <option value="gaelic and english">{translations[siteLanguage].gaelicAndEnglish}</option>
                                        </select>) : (newLanguage)}
            </p>
            {isEditingLanguage ? ( <button className="edit-info-button" onClick={() => handleEditSave("language", newLanguage)}> {translations[siteLanguage].update} </button>) : (<button className="edit-info-button" onClick={() => setIsEditingLanguage(true)}>{translations[siteLanguage].edit}</button>)} 
          </div>
          

        
        </div>
      </>
    )
};

export default EditEvent;